module.exports = __webpack_public_path__ + "static/media/taskFlow.4d14b5f3.png";